import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import NoMatch from 'screens/NoMatch'
import CarrierRFPDetails from 'screens/Carrier/RFPDetails'
import ShipperRFPList from 'screens/Shipper/RFPList'
import ShipperRFPDetails from 'screens/Shipper/RFPDetails'
import ShipperRFPAdd from 'screens/Shipper/RFPAdd'
import ShipperRFPCarriers from 'screens/Shipper/RFPCarriers'
import Login from 'screens/Login'
import TermsOfService from 'screens/TermsOfService'
import PrivateRoute from 'components/PrivateRoute'
import { theme } from 'styles/theme'
import Page from 'components/Page'
import { useAnalytics } from 'hooks/useAnalytics'

export function Router() {
  useAnalytics()

  return (
    <Switch>
      <Route path="/carrier/:linkUUID">
        <Page>
          <CarrierRFPDetails />
        </Page>
      </Route>
      <PrivateRoute exact path="/shipper/rfp">
        <Page>
          <ShipperRFPList />
        </Page>
      </PrivateRoute>
      <PrivateRoute exact path="/shipper/rfp/add">
        <Page>
          <ShipperRFPAdd />
        </Page>
      </PrivateRoute>
      <PrivateRoute exact path="/shipper/rfp/:rfpId">
        <Page>
          <ShipperRFPDetails />
        </Page>
      </PrivateRoute>
      <PrivateRoute exact path="/shipper/rfp/:rfpId/carriers">
        <Page>
          <ShipperRFPCarriers />
        </Page>
      </PrivateRoute>
      <Route exact path="/login">
        <Page color={theme.colors.background}>
          <Login />
        </Page>
      </Route>
      <Route exact path="/terms-of-service">
        <Page color={theme.colors.background}>
          <TermsOfService />
        </Page>
      </Route>
      <Route exact path="/">
        <Redirect to="/shipper/rfp" />
      </Route>
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  )
}
